import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListEnglishIqHistoryV1Response } from './list-english-iq-history-v1-response';
import { listEnglishIqHistoryV1ResponseSchema } from './list-english-iq-history-v1-response';

export async function listEnglishIqHistoryV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListEnglishIqHistoryV1Response>> {
  return getRequest<IListEnglishIqHistoryV1Response>({
    path: '/english-iq/history/v1',
    schema: listEnglishIqHistoryV1ResponseSchema,
    options,
  });
}
